import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/Blogs.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const PAGE_SIZE = 9;

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [category, setCategory] = useState("All");
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
      // Sort by newest first
      const sortedBlogs = response.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setBlogs(sortedBlogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Helper to strip HTML tags and get short excerpt
  const getExcerpt = (html, maxLength = 100) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const categories = [
    "All",
    ...Array.from(new Set(blogs.map((d) => d.category))),
  ];

  const filtered =
    category === "All"
      ? blogs
      : blogs.filter((d) => d.category === category);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const visibleItems = filtered.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  const handlePage = (p) => {
    if (p < 1 || p > totalPages) return;
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <BreadcrumbSection
        title="Blogs"
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <section className="blogs-page">
        <div className="blogs-header container">
          <h2 className="page-title"></h2>

          <div className="filter-bar">
            <label htmlFor="blog-category" className="filter-label">
              Filter by:
            </label>
            <div className="filter-control">
              <select
                id="blog-category"
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setPage(1);
                }}
              >
                {categories.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="container cards-grid">
          <div className="grid-row">
            {visibleItems.slice(0, 3).map((item) => (
              <article
                key={item._id}
                className="blog-card"
                onClick={() => navigate(`/blog/${item._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="thumb">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${item.image}`}
                    alt={item.title}
                    loading="lazy"
                  />
                </div>
                <div className="card-body">
                  <div className="meta">
                    <span className="meta-cat">{item.category}</span>
                    <span className="meta-date">
                      {new Date(item.createdAt).toDateString()}
                    </span>
                  </div>
                  <h3 className="title">{item.title}</h3>
                  <p className="excerpt">{getExcerpt(item.description, 100)}</p>
                  <span className="read-more">Read More...</span>
                </div>
              </article>
            ))}
          </div>

          {visibleItems.length >= 6 && (
            <div className="highlight-row">
              <div className="grid-row">
                {visibleItems.slice(3, 6).map((item) => (
                  <article
                    key={item._id}
                    className="blog-card"
                    onClick={() => navigate(`/blog/${item._id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="thumb">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${item.image}`}
                        alt={item.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="card-body">
                      <div className="meta">
                        <span className="meta-cat">{item.category}</span>
                        <span className="meta-date">
                          {new Date(item.createdAt).toDateString()}
                        </span>
                      </div>
                      <h3 className="title">{item.title}</h3>
                      <p className="excerpt">{getExcerpt(item.description, 100)}</p>
                      <span className="read-more">Read More...</span>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          )}

          <div className="grid-row">
            {visibleItems.slice(6, 9).map((item) => (
              <article
                key={item._id}
                className="blog-card"
                onClick={() => navigate(`/blog/${item._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="thumb">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${item.image}`}
                    alt={item.title}
                    loading="lazy"
                  />
                </div>
                <div className="card-body">
                  <div className="meta">
                    <span className="meta-cat">{item.category}</span>
                    <span className="meta-date">
                      {new Date(item.createdAt).toDateString()}
                    </span>
                  </div>
                  <h3 className="title">{item.title}</h3>
                  <p className="excerpt">{getExcerpt(item.description, 100)}</p>
                  <span className="read-more">Read More...</span>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="container pagination-row">
          <div className="pagination">
            <button
              className="page-btn"
              onClick={() => handlePage(page - 1)}
              disabled={page === 1}
            >
              &lt;
            </button>

            {[...Array(totalPages)].map((_, idx) => {
              const p = idx + 1;
              return (
                <button
                  key={p}
                  className={`page-number ${p === page ? "active" : ""}`}
                  onClick={() => handlePage(p)}
                >
                  {p}
                </button>
              );
            })}

            <button
              className="page-btn"
              onClick={() => handlePage(page + 1)}
              disabled={page === totalPages}
            >
              &gt;
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
